// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"5b6018fb","345":"5b425a8a","424":"01e71a6a","453":"9f73ec63","476":"0db226bd","478":"abd5998c","491":"e7e4e6e5","549":"69d53365","757":"dd204d96"}[chunkId] + ".chunk.js";
};